import type { ReactNode } from "react";
import type { StatusKind } from "../types";

type Props = { kind?: StatusKind; children: ReactNode };

export const StatusBadge = ({ kind = "ok", children }: Props) => (
  <span className={`tp-status ${kind}`}>
    <span className="dot" />
    {children}
  </span>
);
